import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';
import TextField from "@material-ui/core/TextField";
import compose from "recompose/compose";
import {connect} from "react-redux";


import {
	updEditableTableValue
} from "../../../../actions/components";
import {getErrorColor} from "../../../const";

function CurrencyFormatCustom(props) {
	const { inputRef, onChange,min,max, ...other } = props;
	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			isAllowed={(values)=>{
				const {floatValue,value} = values;
				return (floatValue >= min && floatValue <= max) || value === "";
			}}
			thousandSeparator={true}
		/>
	);
}
CurrencyFormatCustom.propTypes = {
	inputRef: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

const styles = {

};

class currencyFormat extends Component {
	constructor(props) {
		super(props);
		this.state = {
			defaultValue : props.value,
			value : props.value,
		};
	}
	handleOnFocus = (event) =>{
		this.setState({
			defaultValue : event.target.value
		})
		event.target.select();
	}
	handleOnChange = (event) =>{
		this.setState({
			value : event.target.value
		})
	}
	handleOnBlur = () =>{
		const {defaultValue, value} = this.state;
		let updValue = value;
		if(value === ""){
			updValue = "0";
			this.setState({
				value:updValue
			})
		}
		if(String(defaultValue) === String(value)) return;


		const {dispatch, id, name} = this.props;
		dispatch(updEditableTableValue({
			id,
			name,
			value:Number(updValue)
		}))
	};
	handleKeyDown = (event)=>{
		if(event.keyCode === 27){
			this.setState({
				value:this.state.defaultValue
			})
		}
	}

	render() {
		const { label, disabled, name, id, min,max,error} = this.props;
		const objectName = name + "_" + id;
		const style = {
			textAlign: 'right',
			fontSize : '0.875rem'
		}
		if(Number(this.state.value) < 0) style["color"] = getErrorColor();

		return (
			<TextField
				label={label}
				name={objectName}
				value={this.state.value}
				onChange={this.handleOnChange}
				onBlur={this.handleOnBlur}
				onFocus={this.handleOnFocus}
				onKeyDown={this.handleKeyDown}
				fullWidth
				disabled={disabled}
				InputProps={{
					inputComponent: CurrencyFormatCustom,
				}}
				inputProps={{
					style: style,
					min:min,
					max:max
				}}
				helperText={error}
				error={Boolean(error)}
			/>
		);
	}
}

currencyFormat.propTypes = {
	value : PropTypes.number,
	label : PropTypes.string,
	max : PropTypes.number,
	min : PropTypes.number,
	disabled : PropTypes.bool,
	error : PropTypes.string,

	id : PropTypes.string.isRequired,
	name : PropTypes.string.isRequired

};
currencyFormat.defaultProps = {
	max : 9999999999,
	min : -9999999999,
	disabled : false,
}
const mapStateToProps = state => {
	return {
		tableState : state.componentsEditableTableState,
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(currencyFormat);



// WEBPACK FOOTER //
// ./src/common/components/table/input/currency-format.js